import React from 'react';
import { connect } from 'react-redux';
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import Draggable from 'react-draggable';
import _ from 'lodash';

import { saveConfig, updateMetrics } from '../../../components/Filter/FilterActions';
import { formatWorkDuration, getWorkMinutesPerDay } from '../../../util/dates';
import chartUtils from '../../../util/chartUtils';
import CardPlaceholder from '../../../components/CardPlaceholder';

import expandIcon from '../../../assets/img/zoom-icon-off.svg';
import collapseIcon from '../../../assets/img/zoom-icon-on.svg';

class FlowStats extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isFullScreen: false };
    this.handleClose = this.handleClose.bind(this);
  }

  handleResize = () => {
    this.setState({ isFullScreen: !this.state.isFullScreen });
  };

  handleClose() {
    this.props.close();
    this.props.saveConfig();
  }

  render() {
    if (!this.props.metrics) {
      return <div></div>;
    }
    if (!this.props.data || !this.props.data.length) {
      return <CardPlaceholder title="Process metrics" shape="table" loading={this.props.isLoading} onClose={this.handleClose} />;
    }

    let rows = this.props.data.map((item) => {
      return (
        <tr key={item.list}>
          <td>
            {item.color &&
              <div className="label_box" style={chartUtils.keyDotStyle(item.color)}></div>
            }
            {item.list}
          </td>
          <td className={item.avgArrivalRate > 0 ? '' : 'is-empty'}>{item.avgArrivalRate > 0 ? item.avgArrivalRate.toFixed(2) : '---'}</td>
          <td className={item.avgThroughput > 0 ? '' : 'is-empty'}>{item.avgThroughput > 0 ? item.avgThroughput.toFixed(2) : '---'}</td>
          <td className={item.avgDailyWIP > 0 ? '' : 'is-empty'}>{item.avgDailyWIP > 0 ? item.avgDailyWIP.toFixed(2) : '---'}</td>
          <td className={item.avgCycleTime > 0 ? '' : 'is-empty'}>
            {item.avgCycleTime > 0
              ? `${item.avgCycleTime.toFixed(2)} (${formatWorkDuration(item.avgCycleTime * getWorkMinutesPerDay(this.props.excludeWeekendOpts, this.props.useWorkingHoursInCycleTimeDays), this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)})`
              : '---'}
          </td>
        </tr>
      );
    });

    return (
      <Draggable defaultPosition={{ x: 95, y: 85 }} axis="both" bounds="parent">
        <div id={this.props.id} className={`box_white_shadow table_metrics ${this.state.isFullScreen ? 'fullscreen' : ''}`}>
          <div className="box_white_title">
            <h3>Process metrics</h3>
            <p className="card-subtitle">Calculated averages</p>
            <div className='right-actions'>
              {this.props.focusable && (
                <Button variant='secondary' size='sm' className={`btn-action ${this.state.isFullScreen ? 'fullscreen' : ''}`} onClick={this.handleResize}>
                  <img src={this.state.isFullScreen ? expandIcon : collapseIcon} alt="toggleFullSreen" />
                </Button>
              )}
              <Button className="btn-action" onClick={this.handleClose}>&times;</Button>
            </div>
          </div>
          
          <Table>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>
                  Arrival rate <br />
                  items/day
                </th>
                <th>
                  Throughput <br />
                  items/day
                </th>
                <th>
                  Daily WIP <br />
                  items
                </th>
                <th>
                  Cycle time <br />
                  days
                </th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        </div>
      </Draggable>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    close: () => dispatch(updateMetrics(false, 'cfd')),
    saveConfig: () => dispatch(saveConfig()),
  };
};

const mapStateToProps = (state) => {
  return {
    metrics: state.filters.cfd.metrics,
    isLoading: chartUtils.statsLoading(state.cfd.isLoading, state.cfd.data, state.cfd.arrivalDepTrends),
    timePrecision: state.filters.timePrecision,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    },
    useWorkingHoursInCycleTimeDays: state.auth.user.config && state.auth.user.config.useWorkingHoursInCycleTimeDays
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlowStats);
